<template>
<div class="row col full-height full-width wrapper-canvas" style="cursor:crosshair;position:relative">
  <canvas
    ref="canvas-handwriting"
    class="col canvas"
    @touchstart="listen__view__on_x_down($event, 'touch')"
    @mousedown="listen__view__on_x_down($event, 'mouse')"
    width=100
    height=100
  >
  </canvas>
</div>
</template>

<script>
import lodash from 'lodash'
import elementResizeEvent from 'element-resize-event'

export default {
  props: ['mode', 'stroke-width'],
  data: function () {
    return {
      state: {
        context: undefined,
        coord: {
          x: 0,
          y: 0
        },
        moveTouch: undefined
      }
    }
  },
  methods: {
    listen__view__on_x_down: function (e, type) {
      const Vue = this
      function mouseLeftUpHandler (e) {
        if (e.which == 1) {
          Vue.$parent.$el.removeEventListener('mousemove', mouseLeftMoveHandler)
          Vue.$parent.$el.removeEventListener('mouseup', mouseLeftUpHandler)
        }
      }
      function touchUpHandler (e) {
        if (Array.prototype.findIndex.call(e.changedTouches, v => v.identifier == Vue.state.moveTouch.identifier) == -1) return
        Vue.state.moveTouch = undefined

        Vue.$parent.$el.removeEventListener('touchmove', touchMoveHandler)
        Vue.$parent.$el.removeEventListener('touchend', touchUpHandler)
      }
      function mouseLeftMoveHandler (e) {
        const newX = e.offsetX;
        const newY = e.offsetY;

        Vue.state.context.beginPath();
        Vue.state.context.moveTo( lastX, lastY );
        Vue.state.context.lineTo( newX, newY );
        Vue.state.context.stroke();
        lastX = newX;
        lastY = newY;
      }
      function touchMoveHandler (e) {
        const idx = Array.prototype.findIndex.call(e.changedTouches, v => v.identifier == Vue.state.moveTouch.identifier)
        if (idx == -1) return
        const touch = e.changedTouches[idx]

        let position = Vue.getOffsetPosition({x: touch.pageX, y: touch.pageY}, Vue.$refs['canvas-handwriting'].offsetParent)
        const newX = position.x;
        const newY = position.y;
        Vue.state.context.beginPath();
        Vue.state.context.moveTo( lastX, lastY );
        Vue.state.context.lineTo( newX, newY );
        Vue.state.context.stroke();
        lastX = newX;
        lastY = newY;
      }
      
      function mouseLeftDownHandler () {
        Vue.$parent.$el.addEventListener('mousemove', mouseLeftMoveHandler)
        Vue.$parent.$el.addEventListener('mouseup', mouseLeftUpHandler)
      }
      function touchDownHandler () {
        Vue.$parent.$el.addEventListener('touchmove', touchMoveHandler)
        Vue.$parent.$el.addEventListener('touchend', touchUpHandler)
      }

      if (Vue.state.coord == undefined) return

      e.preventDefault()
      let lastX, lastY
      if (type == 'touch' && e.which == 0) {
        if (Vue.state.moveTouch != undefined) {
          // Vue.zoomTouch = Vue.copyTouch(e.changedTouches[0])
        } else {
          Vue.state.moveTouch = Vue.copyTouch(e.changedTouches[0])

          let position = Vue.getOffsetPosition({x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY}, Vue.$refs['canvas-handwriting'].offsetParent)

          lastX = position.x
          lastY = position.y
          touchDownHandler()
        }
      } else if (type == 'mouse' && e.which == 1) {
        lastX = e.offsetX
        lastY = e.offsetY
        mouseLeftDownHandler()
      }
    },
    changeMode () {
      const Vue = this
      if (Vue.state.context != undefined)
        if (Vue.mode == 'pen') {
          Vue.state.context.globalCompositeOperation = 'source-over'
          Vue.state.context.strokeStyle = "#222222FF"
        } else {
          Vue.state.context.globalCompositeOperation = 'destination-out'  // destination-out
          Vue.state.context.strokeStyle = "#000000FF"
        }
    },
    changeStrokeWidth () {
      const Vue = this
      if (Vue.state.context != undefined)
        Vue.state.context.lineWidth = Vue.strokeWidth
    },
    clearCanvas () {
      const Vue = this
      if (Vue.state.context != undefined)
        Vue.state.context.clearRect(0, 0, Vue.$refs['canvas-handwriting'].width, Vue.$refs['canvas-handwriting'].height)
    },
    initCanvas () {      
      const Vue = this
      const style = getComputedStyle(Vue.$refs['canvas-handwriting'])

      const width0 = Vue.$refs['canvas-handwriting'].width
      const height0 = Vue.$refs['canvas-handwriting'].height
      const width = parseInt(style.width)
      const height = parseInt(style.height)
      if (width0 != width || height0 != height) {
        Vue.$refs['canvas-handwriting'].width = parseInt(style.width)
        Vue.$refs['canvas-handwriting'].height = parseInt(style.height)
      }
      Vue.state.context = Vue.$refs['canvas-handwriting'].getContext('2d')
      Vue.state.context.lineCap = 'round'
      this.changeMode()
      this.changeStrokeWidth()
    },
    copyTouch: function (touch) {
      return { identifier: touch.identifier, pageX: touch.offsetX, pageY: touch.offsetY };
    },
    getOffsetPosition: function (position, parent) {
      while(parent.offsetParent){
        position.x -= parent.offsetLeft - parent.scrollLeft;
        position.y -= parent.offsetTop - parent.scrollTop;
        parent = parent.offsetParent;
      }
      return position
    }
  },
  watch: {
    mode: function () {
      this.changeMode()
    },
    strokeWidth: function () {
      this.changeStrokeWidth()
    }
  },
  mounted () {
    this.initCanvas()
    elementResizeEvent(this.$el, lodash.debounce(this.initCanvas, 10))
  }
}
</script>

<style scoped>
.wrapper-canvas {
  background-image: repeating-linear-gradient(white 0px, white 31px, teal 32px);
}

.wrapper-canvas::before {
  position: absolute;
  content: '';
  margin-left:30px;
  width: 3px;
  height: 100%;
  background-color: rgba(255,0,0,0.5);
  pointer-events: none;
}
</style>